import React from "react";
import { Car, Phone } from "lucide-react";
import Type1 from "../assets/images/type1.png";
import Type2 from "../assets/images/type2.webp";
import Type3 from "../assets/images/type3.jpg";
import Type4 from "../assets/images/type4.avif";
import Type5 from "../assets/images/about-1.jpg";
import Type6 from "../assets/images/type6.webp";

const VehicleShowcase = () => {
  const vehicles = [
    {
      name: "Swift Dzire / Etios",
      image: Type1,
      category: "Sedan",
    },
    {
      name: "Maruti Ertiga",
      image: Type2,
      category: "SUV",
    },
    {
      name: "Toyota Innova",
      image: Type3,
      category: "MPV",
    },
    {
      name: "Innova Crysta",
      image: Type4,
      category: "Premium MPV",
    },
    {
      name: "Tempo Traveller",
      image: Type5,
      category: "Group Travel",
    },
    {
      name: "Bus",
      image: Type6,
      category: "Large Groups",
    },
  ];

  const handleImageError = (e) => {
    e.target.src = "/path/to/placeholder-image.jpg"; // Add a fallback image path here
  };

  const handleCall = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div id="vehicles" className="bg-[#eaf4fb] py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
            Types of Vehicles we have
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            Elam Travels Trichy provides a wide range of car rental services,
            including luxury, wedding, economy, and SUV rentals. For more
            details, give us a call.
            <span className="inline-flex items-center ml-2 text-teal-600 font-semibold">
              <Phone size={16} className="mr-1" />
              <a
                href="tel:+919940906161"
                className="hover:text-teal-700"
                aria-label="Call +91 9940906161"
              >
                +91 9940906161
              </a>
            </span>{" "}
            or{" "}
            <span className="inline-flex items-center ml-1 text-teal-600 font-semibold">
              <Phone size={16} className="mr-1" />
              <a
                href="tel:+919843654847"
                className="hover:text-teal-700"
                aria-label="Call +91 9843654847"
              >
                +91 9843654847
              </a>
            </span>
          </p>
        </div>

        {/* Vehicle Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehicles.map((vehicle) => (
            <div
              key={vehicle.name}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="relative h-48 bg-yellow-50">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover"
                  onError={handleImageError}
                />
                <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {vehicle.name}
                  </h3>
                </div>
                <p className="flex items-center justify-between text-xl font-semibold text-gray-600">
                  {vehicle.category}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <button
            className="bg-orange-400 hover:bg-orange-500 text-black px-8 py-3 rounded-full font-medium  transition-colors duration-200 inline-flex items-center md:hidden"
            onClick={() => handleCall("+919940906161")}
          >
            <Phone className="mr-2" size={20} />
            Contact Us for Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleShowcase;
